import { AxiosResponse } from 'axios';

import { toast } from 'react-toastify';

import instance from './instance';
import { ProcessPaymentRequest, ProcessPaymentResponse, Purchase } from './types';

export const processPayment = async (
  purchase: Purchase,
  recurlyId: string,
  // Callers that surface the failure themselves (the payment-failed sheet) pass
  // noToast, otherwise the user gets the same error twice.
  { noToast }: { noToast?: boolean } = {}
) => {
  if (!purchase.token_id) {
    throw new Error('Purchase token is missing');
  }

  const requestBody: ProcessPaymentRequest = {
    token: purchase.token_id!,
    email: purchase.email,
    itemCode: recurlyId,
    currency: 'USD',
    projectType: 'soula-virtual',
    three_d_secure_action_result_token_id:purchase.three_d_secure_action_result_token_id,
  };

  try {
    const response: AxiosResponse<ProcessPaymentResponse> = await instance.post(
      '/payment',
      requestBody
    );

    const { data } = response;

    if (!data.data.chargeInvoice) {
      throw new Error('Payment processing error: Charge invoice is missing');
    }

    return data.data.chargeInvoice;
  } catch (error: any) {
    const actionTokenId = error.response?.data?.error?.three_d_secure_action_token_id;
    if (actionTokenId) {
      const err: any = new Error('Three D Secure action required');
      err.three_d_secure_action_token_id = actionTokenId;
      throw err;
    }
    const message = error.response?.data?.error?.transactionError?.message ?? error.message ?? 'Payment failed';
    if (!noToast) {
      toast.error(message);
    }
    // Keep the provider details on the error so callers can map the decline code.
    const err: any = new Error(message);
    err.code = error.response?.data?.error?.code ?? error.response?.data?.code;
    err.decline_code =
      error.response?.data?.error?.decline_code
      ?? error.response?.data?.error?.transactionError?.decline_code;
    err.data = error.response?.data;
    throw err;
  }
};
